import { CalendarIcon, ClockIcon } from 'lucide-react';
import { useEffect, useState } from 'react';
import { formatShortThaiDate } from '../../utils/dateUtils';
import { useAuth } from '../../hooks/useAuth';
import UsernameLabel from '../shared/UsernameLabel';

interface CountdownProps {
  targetDate: Date;
}

export const getCountdownColor = (days: number) => {
  if (days < 0) return 'text-red-500';
  if (days < 1) return 'text-orange-400';
  if (days < 3) return 'text-yellow-500';
  return 'text-green-500';
};

export const Countdown: React.FC<CountdownProps> = ({ targetDate }) => {
  const [countdown, setCountdown] = useState('');
  const [countdownColor, setCountdownColor] = useState('text-green-500');
  const { user } = useAuth();

  useEffect(() => {
    const calculateCountdown = () => {
      const now = new Date();
      const dueDate = new Date(targetDate);

      if (isNaN(dueDate.getTime())) {
        console.error('Invalid due date:', targetDate);
        setCountdown('วันที่ไม่ถูกต้อง');
        return;
      }

      const difference = dueDate.getTime() - now.getTime();
      const days = Math.floor(difference / (1000 * 60 * 60 * 24));

      if (difference > 0) {
        const hours = Math.floor(
          (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
        );
        const minutes = Math.floor(
          (difference % (1000 * 60 * 60)) / (1000 * 60),
        );
        setCountdown(`${days} วัน ${hours} ชั่วโมง ${minutes} นาที`);
        setCountdownColor(getCountdownColor(days));
      } else {
        setCountdown('หมดเวลา');
        setCountdownColor('text-red-500');
      }
    };

    calculateCountdown();
    const timer = setInterval(calculateCountdown, 60000);
    return () => clearInterval(timer);
  }, [targetDate]);

  return (
    <div className="flex flex-col md:flex-row flex-wrap items-center gap-6 justify-center w-full px-2 py-2 bg-white">
      {/* Due Date */}
      <div className="flex flex-col gap-1 items-center">
        {/* Remaining Time */}
        <div className="flex items-center justify-center gap-1 text-sm text-yellow-700">
          <ClockIcon className="w-4 h-4 text-yellow-400" />
          <span>{countdown}</span>
        </div>
        <div className="hidden md:flex justify-start items-start gap-1 text-xs text-gray-700">
          <CalendarIcon className="w-4 h-4 text-gray-400" />
          <span>{formatShortThaiDate(targetDate)}</span>
        </div>
      </div>
    </div>
  );
};

export default Countdown;
